export const REACT_APP_ENV =
  process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";

export const INSTITUTION_ID =
  window.location.hostname === "localhost"
    ? "schools"
    : window.location.hostname.split(".")[0];

export const EDITOR_API_KEY =
  "kxxvj2ulbrz1343adk393qzj7wh0fak7e1zlebcgcxefh2kj";

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const TOP_RIGHT = "top-right";
export const SUCCESS = "success";
export const ERROR = "error";
export const WARNING = "warning";
export const INFO = "info";
export const EMAIL = "email";
export const DOCUMENT = "document";
export const SMS = "sms";
export const DEFAULT_ERROR_MESSAGE =
  "An error occured. Please reload the page to try again.";
export const EMPTY_VALUE = "--/--";
export const MIN_NUMBER_STEPS = 4;
export const LIGHT_ASH = "#f5f5f7";
export const DEEP_BLUE = "#0E405C";
export const PURPLE = "#825efb";
export const SKY_BLUE = "#2EA0D4";

export const PAGE_SIZES = [
  { label: "10 Rows", value: 10 },
  { label: "20 Rows", value: 20 },
  { label: "50 Rows", value: 50 },
  { label: "100 Rows", value: 100 },
];

export const statusCodes = {
  INTERNAL_SERVER_ERROR: 500,
  BAD_REQUEST: 400,
  CONFLICT: 409,
  UNAUTHORIZED: 401,
};

export const questionTypes = [
  { label: "Single Choice", value: "SINGLE_CHOICE" },
  { label: "Multiple Choice", value: "MULTIPLE_CHOICE" },
  { label: "Short Answer", value: "SHORT_TEXT" },
  { label: "Long Answer", value: "LONG_TEXT" },
];

export const DefaultCurriculum = [
  { label: "NUC", value: "NUC" },
  { label: "NBTE", value: "NBTE" },
  { label: "NCCE", value: "NCCE" },
];
